<template>
  <div>
    <nav class="nav-extended" style="margin-bottom: 5rem">
      <div class="nav-wrapper">
        <a href="/" class="brand-logo left"
          > <i class="material-icons large">home</i> SOLTAR <small>{{ $route.name }}</small></a
        >

        <ul id="nav-mobile " class="right">
          <li>
            <a class="mdi mdi-chevron-left" @click="$router.back()" >ATRÁS</a>
          </li>
        </ul>
      </div>
    </nav>
    <div class="container">
      <div>
        <!-- Modal Structure Eventos -->
        <div id="modal-eventos-logistica-dashboard" class="modal">
          <div v-if="carton" class="modal-content">
            <h4>
              Eventos para el carton #{{ carton.no_carton }} de
              {{ carton.total_cartons }}
            </h4>
            <ul>
              <p>
                Actualizado por última vez:
                {{ carton.updated_at.toDate().toLocaleString() }}
                <br />
                Número de trabajo: {{ carton.ccmasterid }}
              </p>
            </ul>

            <div>
              <ul class="collapsible popout">
                <li v-for="(evento, key) in carton_eventos" :key="key">
                  <div class="collapsible-header">
                    <i class="material-icons">schedule</i>
                    {{ evento.created.toDate().toLocaleString() }} -
                    {{ evento.status }}
                  </div>
                  <div class="collapsible-body">
                    <p>
                      <span>{{ evento.desc }}</span>
                      <span v-show="evento.paqueteria_numero_rastreo">
                        Proveedor del servicio: {{ evento.paqueteria_name }}
                        <br />
                        Número de rastreo:
                        {{ evento.paqueteria_numero_rastreo }}
                      </span>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="#!"
              @click="modal_eventos.close()"
              class="modal-close waves-effect btn-flat"
              >Cerrar</a
            >
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 5rem">
        <div class="row">
          <div class="col flow-text">
            <Filtros
              v-show="!loading"
              class="right"
              :shipvias="shipvias"
              :vehiculos="vehiculos"
              @filtro="filtro"
            ></Filtros>

            <span v-show="loading">Cargando...</span>
          </div>
          <div class="col flow-text right"><h5>Consulta de cartones</h5></div>
        </div>

        <div class="row">
          <DataTable
            :responsive="false"
            :parsers="parsers_tabla"
            :data="rows"
            :indexes="Object.keys(rows)"
            :rows="Object.values(rows)"
            :columns="columnas_tabla"
            :row_clicked="carton_clicked"
            export_separator="|"
          ></DataTable>
          <div class="row">
            <div class="col s12 m6 left">
              <button class="btn green" @click="downloadCSVGuias(guias)">
                DESCARGAR CONCENTRADO DE GUÍAS
              </button>
            </div>
            <div class="col s12 m6 right">
              <button @click="rows = {}" class="btn-flat mdi mdi-delete">
                limpiar tabla
              </button>
            </div>
          </div>
        </div>

        <div class="card-action"></div>
      </div>
    </div>
  </div>
</template>
<script>
import M from "materialize-css";
import firebase from "firebase/app";
import Filtros from "./modal-filtros";
import DataTable from "../../../datatable";
export default {
  components: { Filtros, DataTable },
  computed: {
    guias() {
      let guias = {};
      Object.values(this.cartons).forEach((carton) => {
        let tracknumber = carton.paqueteria_numero_rastreo,
          ccmasterid = carton.ccmasterid,
          dsforderid = carton.dsforderid;
        if (tracknumber != undefined) {
          if (guias[ccmasterid] != undefined) {
            guias[ccmasterid]["total_paquetes"]++;
          } else {
            guias[ccmasterid] = {
              ccmasterid,
              dsforderid,
              paqueteria: carton.paqueteria_name,
              numero_guia: tracknumber,
              total_paquetes: 1,
              ultima_actualizacion: carton.updated,
            };
          }
        }
      });
      return guias;
    },
    carton() {
      if (this.carton_clicked_id && this.cartons[this.carton_clicked_id])
        return this.cartons[this.carton_clicked_id];
      return undefined;
    },
    carton_eventos() {
      if (this.carton_clicked_id && this.cartons[this.carton_clicked_id]) {
        let eventos = this.cartons[this.carton_clicked_id].eventos;
        return [...eventos].reverse();
      }
      return [];
    },
  },
  updated() {},
  created() {
    setTimeout(() => {
      var elems = document.querySelectorAll(".collapsible");
      M.Collapsible.init(elems, {});
      let modal_eventos = document.querySelector(
        "#modal-eventos-logistica-dashboard"
      );
      this.modal_eventos = M.Modal.init(modal_eventos, {});
    }, 0);
  },
  data() {
    let timestamparser = (row, key) =>
      row[key] ? row[key].toDate().toLocaleString() : "No definido";
    return {
      vehiculos: window.vehiculos,
      shipvias: window.shipvias,
      user: window.user,
      db: firebase.firestore(),
      modal_eventos: undefined,
      parsers_tabla: {
        _sydescription: (row, key) => `${row["shipviaid"]}\t${row[key]}`,
        devuelto: timestamparser,
        descargado: timestamparser,
      },
      columnas_tabla: {
        ccmasterid: "Trabajo",
        dsforderid: "Orden de DSF",
        jobpart: "Parte",
        no_carton: "# Carton",
        //shipviaid: "ShipviaId",
        shipviaid: "#Id",
        shipviadesc: "Vía de envío",
        iclocdesc: "Almacén",
        location: "Locación",
        descargado: "Descargado",
        devuelto: "Devuelto",
        status: "Status",
        vehiculo: "Vehículo",
        paqueteria_name: "Paquetería",
        paqueteria_numero_rastreo: "# de guía",
        updated: "Última modificación",
      },
      cartons: {},
      rows: {},
      carton_clicked_id: undefined,
      filtros: {},
      loading: false,
    };
  },
  methods: {
    downloadCSVGuias() {
      let data = this.guias;
      if (Object.keys(data).length == 0)
        return M.toast({
          html: " No hay registros para descargar",
          classes: "orange mdi mdi-alert",
        });

      let columns = {
        ccmasterid: "Trabajo",
        dsforderid: "Num. de orden",
        paqueteria: "Paqueteria",
        numero_guia: "Num. de Guia",
        total_paquetes: "Paquetes escaneados",
        ultima_actualizacion: "Ultima actualizacion",
      };

      let blob = this.csvReportBlob(data, columns),
        filename = "reporte.csv";

      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    csvReportBlob(data, columns) {
      let separador = ",",
        values = Object.values(data),
        csv = [Object.keys(columns).join(separador)];

      values.forEach((row) => {
        let csv_row = [];
        Object.keys(columns).forEach((column) => {
          if (this.parsers && this.parsers[column])
            csv_row.push(this.parsers[column](row, column));
          else csv_row.push(row[column]);
        });
        csv.push(csv_row.join(separador));
      });
      let csvstring = csv.join("\n");
      let blob = new Blob([csvstring], { type: "text/csv;charset=utf-8;" });
      return blob;
    },
    mixDateTime(dateStr, timeStr) {
      let params = dateStr
        .split("-")
        .map((n) => n * 1)
        .concat(timeStr.split(":").map((n) => n * 1));
      params[1]--;
      let date = new Date(...params);
      return date;
    },
    fullscreen() {
      document.querySelector("body").requestFullscreen();
    },
    carton_clicked(cartonId) {
      this.carton_clicked_id = cartonId;

      setTimeout(() => {
        var elems = document.querySelectorAll(".collapsible");
        M.Collapsible.init(elems, {});

        this.modal_eventos.open();
      }, 100);
    },
    signOut() {
      firebase.auth().signOut();
    },
    filtro(filtros) {
      this.filtros = filtros;
      let query = this.db.collection("cartons"),
        cartons = {},
        start_at = new Date(filtros.updated_at_start_date),
        end_at = filtros.updated_at_end_date;

      start_at = this.mixDateTime(
        filtros.updated_at_start_date,
        filtros.updated_at_start_time
      );
      end_at = this.mixDateTime(
        filtros.updated_at_end_date,
        filtros.updated_at_end_time
      );
      if (!(filtros.ccmasterid && filtros.ccmasterid && filtros.ccmasterid))
        query = query
          .where("updated_at", ">=", start_at)
          .where("updated_at", "<=", end_at)
          .orderBy("updated_at", "asc");
      if (filtros.ccmasterid)
        query = query.where("ccmasterid", "==", filtros.ccmasterid);
      if (filtros.dsforderid)
        query = query.where("dsforderid", "==", filtros.dsforderid);
      if (filtros.paqueteria_numero_rastreo) {
        if (filtros.paqueteria_numero_rastreo.localeCompare("{no-nula}") == 0) {
          query = query

            .orderBy("paqueteria_name", "asc")
            .orderBy("paqueteria_numero_rastreo", "asc")
            .orderBy("ccmasterid", "asc")
            .orderBy("no_carton", "asc")
            .startAfter(null);
        } else
          query = query.where(
            "paqueteria_numero_rastreo",
            "==",
            filtros.paqueteria_numero_rastreo
          );
      }

      if (filtros.vehiculo)
        query = query.where("vehiculo", "==", filtros.vehiculo);
      if (filtros.shipviaid)
        query = query.where("shipviaid", "==", filtros.shipviaid);
      if (filtros.iclocid)
        query = query.where("iclocid", "==", filtros.iclocid + "");

      this.loading = true;
      query.limit(1000).get()      
      .then((snap) => {
        if (snap.docs.length == 0)
          M.toast({
            html: "No hay datos para mostrar con esta consulta",
            classes: "red",
            displayLength: 5e3,
          });
        else {
          snap.docs.forEach((doc) => {
            cartons[doc.id] = doc.data();
          });
          this.cartons = this.rows = cartons;
          console.log(cartons);
          this.$forceUpdate();
          M.toast({
            html: `${snap.docs.length} Documentos encontrados`,
            classes: "green",
          });
          M.AutoInit();
        }
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
